import React from 'react';
import cx from 'classnames';

interface Props {
  onClick: () => void;
  hasSeeAddress: boolean;
  dataValue?: string;
}

export const RevealAddress = ({ onClick, hasSeeAddress, dataValue }: Props) => {
  const dataValueMessage = dataValue ? `${dataValue}` : '';
  const seeAddressClass = cx(
    'gtmSeeAddress ml4 f14 fw6 abbey underline transition-ease nowrap fl',
    {
      'o-0': hasSeeAddress,
      'o-1 pointer': !hasSeeAddress,
      w1: hasSeeAddress,
    },
  );

  if (hasSeeAddress) {
    return null;
  }

  return (
    <a
      className={seeAddressClass}
      onClick={onClick}
      title="Ver endereço"
      data-value={dataValueMessage}
    >
      Ver endereço
    </a>
  );
};
